import { render, staticRenderFns } from "./ElectronicMoneyDetail.vue?vue&type=template&id=7a0efed8&scoped=true&"
import script from "./ElectronicMoneyDetail.vue?vue&type=script&lang=js&"
export * from "./ElectronicMoneyDetail.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicMoneyDetail.vue?vue&type=style&index=0&id=7a0efed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0efed8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardText,VSubheader})
